import React, { Component, Props } from "react";
import { carouselProps } from "../../../interfaces/interfaces";
import ImageSlide from "./ImageSlide";
import Arrow from "./Arrow";

import equipment from "../../../media/reduced-images/equipment.jpg";
import lab from "../../../media/reduced-images/lab.jpg";
import packaging from "../../../media/reduced-images/packaging.jpg";
import outside from "../../../media/reduced-images/outside-straight.jpg";

import styles from "./ImageCarousel.module.scss";
import { NavLink } from "react-router-dom";

class ImageCarousel extends Component<carouselProps> {
  state: carouselProps;
  images: string[] = [equipment, lab, packaging, outside];
  carouselTimer: number;
  fadeTimer: number;
  backgroundTimer: number;

  fadeTime: number = 2000;
  displayTime: number = 4000;
  backgroundDelay: number = 50;

  constructor(props: carouselProps) {
    super(props);
    this.state = { ...props };
    this.carouselTimer = window.setInterval(() => {
      this.nextSlide();
    }, 4000);
    this.fadeTimer = 0;
    this.backgroundTimer = 0;
  }

  nextSlide() {
    if (this.state.inTransition) return;

    let length = this.images.length;
    let shouldReset = this.state.carouselIndex == length - 1;
    let newIndex = shouldReset ? 0 : this.state.carouselIndex + 1;
    let nextIndex = newIndex + 1 == length ? 0 : newIndex + 1;

    clearInterval(this.carouselTimer);
    clearInterval(this.fadeTimer);
    clearInterval(this.backgroundTimer);

    this.setState({ fading: "fade", inTransition: true }, () => {
      this.fadeTimer = window.setTimeout(() => {
        this.setState({
          fading: "no",
          carouselIndex: newIndex
        });
        // change the background image after to avoid flicker on firefox
        this.backgroundTimer = window.setTimeout(() => {
          this.setState({ nextIndex: nextIndex, inTransition: false });
        }, this.backgroundDelay);
        this.carouselTimer = window.setInterval(
          () => this.nextSlide(),
          this.displayTime
        );
      }, this.fadeTime - this.backgroundDelay);
    });
  }

  previousSlide() {
    if (this.state.inTransition) return;

    let length = this.images.length;
    let shouldReset = this.state.carouselIndex == 0;
    let newIndex = shouldReset ? length - 1 : this.state.carouselIndex - 1;
    let nextIndex = newIndex + 1 == length ? 0 : newIndex + 1;

    clearInterval(this.carouselTimer);
    clearInterval(this.fadeTimer);
    clearInterval(this.backgroundTimer);

    this.setState({ nextIndex: newIndex, inTransition: true }, () => {
      this.setState({ fading: "fade" }, () => {
        this.fadeTimer = window.setTimeout(() => {
          this.setState({
            fading: "no",
            carouselIndex: newIndex
          });
          // change the background image after to avoid flicker on firefox
          this.backgroundTimer = window.setTimeout(() => {
            this.setState({ nextIndex: nextIndex, inTransition: false });
          }, this.backgroundDelay);
          this.carouselTimer = window.setInterval(
            () => this.nextSlide(),
            this.displayTime
          );
        }, this.fadeTime - this.backgroundDelay);
      });
    });
  }

  render() {
    const nextBackgroundProperties = {
      backgroundImage: `url(${this.images[this.state.nextIndex]})`,
      backgroundSize: "cover",
      backgroundPosition: "center"
    };
    return (
      <div id={styles.carouselContainer} style={nextBackgroundProperties}>
        <ImageSlide
          imageURL={this.images[this.state.carouselIndex]}
          nextImageURL={this.images[this.state.nextIndex]}
          fading={this.state.fading}
        />
        <div id={styles.textPanelContainer}>
          <div id={styles.textPanel}>
            <div id={styles.text}>Experts in Contract Manufacturing</div>
            <NavLink to="/about-us" id={styles.aboutUsLink}>
              Learn More
            </NavLink>
          </div>
        </div>
        <div className={styles.arrow} id={styles.left}>
          <Arrow
            direction={"left"}
            icon={"arrow_back"}
            clickFunction={this.previousSlide.bind(this)}
          />
        </div>
        <div className={styles.arrow} id={styles.right}>
          <Arrow
            direction={"right"}
            icon={"arrow_forward"}
            clickFunction={this.nextSlide.bind(this)}
          />
        </div>
      </div>
    );
  }
}

export default ImageCarousel;
